module.exports = __webpack_public_path__ + "img/wxshare.d19ab65f.png";